<template>
  <div class="map-wrapper">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="1000"
      height="400"
      viewBox="0 0 476.25 317.5"
      style="position:absolute;top:0; z-index:99999;display:none"
    >
      <defs>
        <linearGradient id="a">
          <stop offset="0" stop-color="#093f7f" />
          <stop offset="1" stop-color="#b3db11" />
        </linearGradient>
        <linearGradient
          xlink:href="#a"
          id="b"
          x1="-75.401"
          y1="126.199"
          x2="222.629"
          y2="126.199"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1.42718 0 0 1 120.036 4.085)"
        />
      </defs>
      <path
        fill="url(#b)"
        d="M12.425 111.646h425.344v37.275H12.425z"
        transform="translate(0 20.5)"
      />
    </svg>
    <l-map id="map2" ref="map" :zoom="zoom" :center="center" :bounds="bounds" :options="mapOptions">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-geo-json
        :geojson="json"
        :options="geojsonOptions"
        @mouseout="onMouseout"
        @mouseover="onMouseover"
        @click="toggleLayer"
      ></l-geo-json>
    </l-map>
    <svg @click="onArrowClick" class="arrow" width="50" height="50" viewBox="0 0 25 50">
      <path d="M 25 0 L 0 25 L 25 50" fill="none" stroke="rgba(0,0,0,0.8)" stroke-width="8" />
    </svg>

    <div class="map-legend">
      <div class="legend-title">{{legend.title}}</div>
      <table>
        <tr v-for="(item, i) in legend.body" :key="i">
          <td>{{item.text}}</td>
          <td>
            <div style="width:25px; height:25px" :style="{backgroundColor:item.color}"></div>
          </td>
        </tr>
      </table>
    </div>

    <div class="map-hud">
      <div class="map-hud-controls">
        <svg @click="onCloseClick" class="close" width="20" height="20" viewBox="0 0 25 25">
          <line x1="0" y1="0" x2="25" y2="25" fill="none" stroke-width="3" />
          <line x1="0" y1="25" x2="25" y2="0" fill="none" stroke-width="3" />
        </svg>
        <button
          class="filter-button"
          @click="filter==='stadtteile'?filter='bezirke':filter='stadtteile'"
        >{{filter==="stadtteile"?"Bezirke":"Stadtteile"}}</button>
        <button
          class="filter-button"
          @click="filter2==='themenfelder'?filter2='kategorien':filter2='themenfelder'"
        >{{filter2==="themenfelder"?"kategorien":"themenfelder"}}</button>
      </div>
      <div class="map-hud-content">
        <div class="map-hud-title"></div>
        <table>
          <tr>
            <td>{{feature.properties.NAME}}</td>
            <td style="width:50px;text-align:right">{{feature.properties.total}}</td>
          </tr>
          <tr v-for="(item,i) in sort(feature.properties[filter2])" :key="i">
            <td>{{item.name}}</td>
            <td
              style="width:50px;text-align:right"
            >{{`${Math.round(item.count/feature.properties.total*100)}%`}}</td>
            <td>
              <svg class="bar" width="100px" height="100%">
                <rect :id="'bar'+i" height="100%" :width="item.count/feature.properties.total*100" />
              </svg>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="map-input"></div>
  </div>
</template>

<script>
import _ from "lodash";
import { TweenMax, TimelineLite } from "gsap";
import {
  LMap,
  LTileLayer,
  LMarker,
  LGeoJson,
  LPopup,
  PopupContent
} from "vue2-leaflet";
import axios from "axios";

import { default as grenze } from "../../assets/geojson/auswertung/grenze.json";
import { default as bezirke } from "../../assets/geojson/auswertung/bezirke.json";
import { default as stadtteile } from "../../assets/geojson/auswertung/stadtteile.json";
import { default as markers } from "../../assets/geojson/auswertung/markers";

import * as L from "leaflet";
import pointsWithinPolygon from "@turf/points-within-polygon";
import Cluster from "vue2-leaflet-markercluster";
import { mapState } from "vuex";

const tl = new TimelineLite();

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LGeoJson,
    LPopup,
    Cluster
  },
  data() {
    return {
      filter: "stadtteile",
      filter2: "themenfelder",
      activeLayerId: null,
      feature: grenze.features[0],

      /////////////////////////////////////////////////////////////////////////////////////
      // selectedData: stadtteile.features.properties,
      // MAP
      apiUrl: "https://dachaudenktweiter.de/api",
      text: null,
      mapOptions: {
        // scrollWheelZoom: false,
        // doubleClickZoom: false,
      },
      maxZoom: 13,
      zoom: 13,
      center: [48.266132, 11.442426],
      bounds: L.latLngBounds(L.geoJSON(grenze).getBounds()),
      url: "http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png",
      // url: "https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png",
      attribution: `
      &copy; <a target="blank" href="http://www.openstreetmap.org/copyright">OpenStreetMap-Mitwirkende</a>
      `,
      // HUD
      // disableHud: true,

      // LAYER OPTIONS

      // selectedPolygonName: "stadtteile",

      legend: {
        title: "Beiträge",
        body: [
          { n: 10, text: "0 bis 9", color: "#0A407F" },
          { n: 50, text: "10 bis 49", color: "#265A6B" },
          { n: 100, text: "50 bis 99", color: "#457658" },
          { n: 200, text: "100 bis 199", color: "#608F46" },
          { n: 100000, text: "ab 200", color: "#93BE25" }
        ]
      },
      geojsonOptions: {
        weight: 1,
        fillOpacity: 0.7,
        opacity: 1,
        color: "white",
        onEachFeature: (feature, layer) => {
          const count = pointsWithinPolygon(markers, feature).features.length;
          const item = this.legend.body;

          if (count <= item[0].n) layer.setStyle({ fillColor: item[0].color });
          else if (count < item[1].n)
            layer.setStyle({ fillColor: item[1].color });
          else if (count < item[2].n)
            layer.setStyle({ fillColor: item[2].color });
          else if (count < item[3].n)
            layer.setStyle({ fillColor: item[3].color });
          else if (count < item[4].n)
            layer.setStyle({ fillColor: item[4].color });
          else if (count < item[5].n)
            layer.setStyle({ fillColor: item[5].color });
        }
      },

      //HUD
      hudIsActive: false,
      selectedLayerId: null
    };
  },
  mounted() {
    this.allMarkers = markers;
    this.themenfelder = [
      ...new Set(markers.features.map(item => item.properties.themenfeld))
    ];
  },
  computed: {
    json() {
      if (this.filter === "stadtteile") return stadtteile;
      else return bezirke;
    }
  },

  methods: {
    sort(val) {
      return _.orderBy(val, ["count"], ["desc"]);
    },
    onMouseover(e) {
      e.layer.bindTooltip(e.layer.feature.properties.NAME).openTooltip();

      e.layer.setStyle({
        fillOpacity: 0.8
        // weight: 2
      });
    },
    onMouseout(e) {
      e.layer.setStyle({
        fillOpacity: 0.7
        // weight: 1
      });
      // this.feature = null;
    },
    toggleLayer(e) {
      if (!this.hudIsActive) this.onArrowClick();
      // TOGGLE ON
      if (!this.activeLayerId || this.activeLayerId !== e.layer._leaflet_id) {
        // SET STYLE
        this.activeLayerId = e.layer._leaflet_id;
        this.resetLayerStyle();
        this.setLayerStyle(e.layer);
        // SET DATA
        this.feature = e.layer.feature;
        // TOGGLE OFF
      } else {
        // SET RESET
        this.activeLayerId = null;
        this.resetLayerStyle();
        // RESET DATA
        this.feature = grenze.features[0];
      }
    },
    setLayerStyle(layer) {
      layer.setStyle({ weight: 3 });
    },
    resetLayerStyle() {
      const map = this.$refs.map;
      const layers = map.mapObject.eachLayer(layer => {
        if (layer.feature) {
          layer.setStyle({ weight: 1 });
        }
      });
    },
    onArrowClick() {
      this.hudIsActive = true;
      tl.to(".arrow", 0.2, { opacity: 0 })
        .to(".map-hud", 0.2, { transform: "scaleX(1)" })
        .from(".map-hud *", 0.2, {
          opacity: 0
        })
        .to(".close", 0.2, { transform: "scale(1)" });
    },
    onCloseClick() {
      this.hudIsActive = false;
      tl.to(".close", 0.2, { transform: "scale(0)" })
        .from(".map-hud *", 0.2, { opacity: 1 })
        .to(".map-hud", 0.2, {
          transform: "scaleX(0)"
        })
        .to(".arrow", 0.2, { opacity: 1 });
    }
  }
};
</script>
<style scoped lang="scss">
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

$hud-color: white;
$hud-background: rgba(0, 0, 0, 0.8);

.map-wrapper {
  // padding: 50px;
  position: relative;
}
.map-legend,
.map-hud {
  // margin: 5px;
}
.map-legend {
  position: absolute;
  bottom: 0;
  left: 0;
  background: $hud-background;
  // background: black;
  z-index: 9999;
  color: $hud-color;
  padding: 10px;
  .legend-title {
    margin-bottom: 10px;
    width: 100%;
    font-size: 18px;
    text-align: center;
  }
  td {
    padding: 0;
    font-size: 14px;
    opacity: 0.7;
  }
}
.map-hud {
  overflow-y: scroll;
  font-size: 14px;
  transform: scaleX(0);
  transform-origin: right;
  z-index: 9999;
  position: absolute;
  height: 100%;
  width: 100%;
  background: $hud-background;
  bottom: 0;
  right: 0;
  padding: 20px;
  color: $hud-color;
  .filter-button {
    border-radius: 5px;
    color: $hud-color;
    background: rgba(44, 44, 44, 0.8);
    filter: brightness(150%);

    &:hover {
      background: rgba(56, 56, 56, 0.9);
    }
  }
  td {
    word-break: break-word;
    // min-width: 50px;
    // max-width: 200px;
    height: 35px;
    vertical-align: center;
  }
}
.map-hud-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.map-hud-title {
  width: 100%;
  // text-align: center;
  margin-bottom: 10px;
  padding: 2px;
  span {
    font-size: 18px;
  }
}
.arrow {
  padding: 5px;
  cursor: pointer;
  z-index: 9998;
  position: absolute;
  top: 45%;
  right: 0;
  path {
    stroke-linecap: square;
  }
}
.close {
  padding: 2.5px;
  margin: 2.5px;
  cursor: pointer;
  transform: scale(0);
  line {
    stroke: $hud-color;
    stroke-linecap: round;
  }
}
svg {
  &.bar {
    height: 30px;
    rect {
      fill: $hud-color;
      transition: width 0.5s ease-out;
    }
  }
}
.map-input {
  z-index: 9999;
  position: absolute;
  background: $hud-background;
  top: 0;
  left: 0;
  margin: 5px;
  select {
    outline: none;
    padding: 5px;
    color: $hud-color;
    border: none;
    background: $hud-background;
  }
}
#map2 {
  width: 100%;
  height: 500px;
}
@media (min-width: 768px) {
  .vue2leaflet-map {
    height: 600px;
  }
  .map-hud {
    width: 400px;
  }
  .map-legend {
    td {
      padding: 5px;
      font-size: inherit;
    }
  }
}
</style>